import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "@/features/auth/hooks/use-auth-react";
import { PartnerApiClien } from "@/features/partner/api-client/api-client";
import { Routes } from "@/features/router";
import { AuthApiClient } from "@/features/user/api-client/api-client";
import { identityPartners, UserType } from "@/features/user/types";
import { useAppSelector } from "@/redux/hooks";
import { OlkyPassRoutes } from "@/utils/routes";
import { FromURL } from "../types";
import { useOrigin } from "./use-origin";

export const useManipulatePartner = () => {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const { block } = useParams();
  const mirror_uuid = useAppSelector((state) => state.signup.mirror_uuid);
  const tempUuid = sessionStorage.getItem("temp_uuid_real");
  const [searchParams] = useSearchParams();
  const redirectToLvl = searchParams.get("level_to_complete");
  const origin = useOrigin();

  const followRoute = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get("r");

      const route =
        (redirectToLvl
          ? `${OlkyPassRoutes.level}?level_to_complete=${redirectToLvl}`
          : redirect && decodeURIComponent(redirect)) ||
        Routes.dashboard ||
        "";
      navigate(route);
    } catch (_) {
      document.location = "/";
    }
  };

  const manipulatePartner = async (user?: UserType) => {
    const partnerUuid = async () => {
      if (origin === FromURL.None) return null;
      const partnerUuidSessionStorage = sessionStorage.getItem("partner_uuid");
      if (partnerUuidSessionStorage) return partnerUuidSessionStorage;

      try {
        const partnerUuidResponse = await PartnerApiClien.getPartnerUuid();
        return partnerUuidResponse?.data?.partner_uuid || null;
      } catch (_) {
        return null;
      }
    };
    const partner_uuid = await partnerUuid();
    if (user?.identityPartners) {
      const found = user?.identityPartners?.find(
        (partner: identityPartners) => partner.uuid === partner_uuid
      );
      const isLevel2 =
        found?.minimum_olkypass_level &&
        user.olkyPassLevel.olkypass_status.level >= found?.minimum_olkypass_level
          ? true
          : false;
      if (found && isLevel2) {
        navigate(
          redirectToLvl
            ? `${Routes.document_consent}?level_to_complete=${redirectToLvl}`
            : Routes.document_consent
        );
        return;
      }
    }
    if (partner_uuid) {
      sessionStorage.removeItem("partner_uuid");
      const profile = await AuthApiClient.profile();
      if (
        (redirectToLvl &&
          profile.olkyPassLevel?.olkypass_status?.level === Number(redirectToLvl) - 1) ||
        Number(redirectToLvl) === 1
      ) {
        navigate(`${OlkyPassRoutes.level}?level_to_complete=${redirectToLvl}`);
      } else if (profile.olkyPassLevel?.olkypass_status?.level >= 2) {
        // redirect to kypay
        navigate(OlkyPassRoutes.kypay);
      } else {
        sessionStorage.removeItem("ConnectedPartner");
        followRoute();
      }
    } else {
      if (block !== "required_field" && !mirror_uuid && !tempUuid)
        if (redirectToLvl) {
          navigate(`${OlkyPassRoutes.level}?level_to_complete=${redirectToLvl}`);
        } else {
          refresh(true);
        }
      else navigate(`${OlkyPassRoutes.dashboard}`);
    }
  };
  return manipulatePartner;
};
